import * as z from 'zod';
import { CURRENCY } from 'src/types';
import { validationMessagesMap } from 'src/utils/messages';
import { REFERENCE_RATE_UNIT } from 'src/features/referenceRates/utils/types';

const referenceRateBaseSchema = z.object({
    name: z.string().nonempty().max(256),
    code: z.string().nonempty().max(64),
    unit: z.enum(REFERENCE_RATE_UNIT),
    /** Required for a currency rate, sent as null for every other unit. */
    currency: z.enum(CURRENCY).optional().nullable(),
    description: z.string().max(1024).optional().nullable(),
    is_active: z.boolean().optional().nullable(),
});

export type ReferenceRateFormSchemaValues = z.infer<typeof referenceRateFormSchema>;
export const referenceRateFormSchema = referenceRateBaseSchema.superRefine((values, ctx) => {
    if (values.unit === REFERENCE_RATE_UNIT.CURRENCY && !values.currency) {
        ctx.addIssue({
            path: ['currency'],
            code: 'custom',
            message: validationMessagesMap.validationErrorRequired,
        });
    }
});

export type PatchReferenceRateFormSchemaValues = z.infer<typeof patchReferenceRateFormSchema>;
export const patchReferenceRateFormSchema = referenceRateBaseSchema.partial();
